import React, { useEffect } from 'react'
import Header from '../headerone/Main'
import Blog from '../menhome/Blog'
import Counter from '../menhome/Counter'
import Event from '../menhome/Event'
import Intro from '../menhome/Intro'
import Mayor from '../menhome/Mayor'
import Newlast from '../menhome/Newlast'
import Portfolio from '../menhome/Portfolio'
import Service from '../menhome/Service'
import Slider from '../menhome/Slider'
import Testimonial from '../menhome/Testimonial'

function Main() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Liberia National Police Website";
  }, [])

  return (
    <>
        <Header/>

        <div className="page-wrapper">
            <Slider/>
            <Mayor/>
            <Service/>
            <Counter/>
            <Intro/>
            <Portfolio/>
            <Testimonial/>
            <Event/>
            <Blog/>
            <Newlast/>
        </div>

    </>
  )
}

export default Main